<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["HFS"][obj_ahfs.I > 0? "EHFS": "AHFS"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="12">
                                        <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["HFS"]["BD"]}}  </h6>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6" v-if="getUserInfo.AT !== 4">
                                        <label class="col-form-label-sm">{{this.getLanguage["RS"]["BN"]}}<span class="required" /> :</label>
                                        <customtreeselect :multiple="false"
                                                          :options="dd_agentgroup"
                                                          :flat="true"
                                                          :defaultExpandLevel="Infinity"
                                                          :clearable="false"
                                                          :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                          v-model="obj_ahfs['AGIT']"
                                                          @input="AgentGroupChange"
                                                          :disabled="obj_ahfs.I > 0"
                                                          ref="AGIT" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["GL"]["SAGT"]}} :</label>
                                        <treeselect :multiple="false"
                                                    :async="true"
                                                    :flat="true"
                                                    :key="rtSubBrand"
                                                    :load-options="loadSubBrandOptions"
                                                    :cacheOptions="false"
                                                    :options="dd_subagentgroup"
                                                    :defaultOptions="dd_DefaultSubBrand"
                                                    :disable-branch-nodes="true"
                                                    :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                    :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                                    :noResultsText="this.getLanguage['GL']['NRF']"
                                                    v-model="obj_ahfs.SAGAGI"
                                                    @input="SubAgentGroupChange"
                                                    openDirection="below"
                                                    :disabled="obj_ahfs.I > 0" />
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["HFS"]["HFST"]}} :</label>
                                        <span class="WCMsg" v-if="this.obj_ahfs.HFST != null">{{ this.obj_ahfs.HFST.length }} / 100 </span>
                                        <span class="WCMsg" v-else> 0 / 100 </span>
                                        <CInput maxlength="100" :placeholder="getLanguage['HFS']['HFST']" size="sm" v-model="obj_ahfs.HFST"/>
                                    </CCol>                                   
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <h6 class="card-title section-title2"><span>2</span>{{this.getLanguage["HFS"]["SHFS"]}}  </h6>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["HFS"]["DN"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="true"
                                                    :options="dd_do"
                                                    :placeholder="this.utilGetDDLanguage('HFS.DN')"
                                                    :noOptionsText="this.getLanguage['GL']['NOA']"
                                                    v-model="obj_ahfs['DIT']"
                                                    @input="DomainChange"
                                                    :disabled="obj_ahfs.I > 0"
                                                    ref="DN">
                                            <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }">
                                                {{ node.label }} <i v-if="node.id.endsWith('-0')" class='fa-solid fa-globe text-info ml-1'></i>
                                            </label>
                                        </treeselect>
                                        <span class="ErrMsg">{{ ValidationErrMsg('DIT','DN') }}</span>
                                    </CCol>
                                    <CCol col="6" class="form-group">
                                        <label class="col-form-label-sm">{{this.getLanguage["HFS"]["L"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_lang"
                                                    :placeholder="this.utilGetDDLanguage('HFS.L')"
                                                    :noOptionsText="this.getLanguage['GL']['NOA']"
                                                    v-model="obj_ahfs['L']"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`"
                                                    ref="L">
                                            <div slot="value-label" slot-scope="{ node }">
                                                <span v-for="(data,index) in dd_lang" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                                <span>{{ node.label }}</span>
                                            </div>
                                            <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                                <span v-for="(data,index) in dd_lang" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                                <span>{{ node.label }}</span>
                                            </div>
                                        </treeselect>
                                        <span class="ErrMsg">{{ ValidationErrMsg('L','L') }}</span>
                                    </CCol>
                                </CRow>

                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["HFS"]["HS"]}} :</label>
                                        <textarea vertical="" rows="10" class="form-control form-control-sm" :value="obj_ahfs.HS" @change="TextValueChange('HS',$event)" v-shortkey.avoid />
                                        <label class="col-form-label-sm">{{this.getLanguage["HFS"]["HSD"]}}</label>
                                    </CCol>

                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["HFS"]["FS"]}} :</label>
                                        <textarea vertical="" rows="10" class="form-control form-control-sm" :value="obj_ahfs.FS" @change="TextValueChange('FS',$event)" v-shortkey.avoid />
                                        <label class="col-form-label-sm">{{this.getLanguage["HFS"]["FSD"]}}</label>
                                    </CCol>
                                </CRow>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton :disabled="sensBtn" color="outline-info" size="sm" @click="saveHFS()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["HFS"]["HFS"]}}</h2>
                        <CButton v-if="checkModuleAccess2(constAccessType.add)" size="sm" color="outline-info" @click="addHFS()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage["HFS"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="dd_DefaultSubBrand"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            v-model="str_FV[4].FV"
                                            openDirection="below"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["HFS"]["DN"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_dofs"
                                            :placeholder="this.utilGetDDLanguage('HFS.DN')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="str_FV[1].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["HFS"]["L"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_langfs"
                                            :placeholder="this.utilGetDDLanguage('HFS.L')"
                                            v-model="str_FV[2].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`">
                                    <div slot="value-label" slot-scope="{ node }">
                                        <span v-for="(data,index) in dd_langfs" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                    <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                        <span v-for="(data,index) in dd_langfs" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                </treeselect>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["HFS"]["HFSL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["HFS"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["HFS"]["L"]}}<i @click="setSortTable('L')" :class="setSortLogo('L')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["HFS"]["HFST"]}}</th>
                                <th>{{this.getLanguage["HFS"]["HS"]}}</th>
                                <th>{{this.getLanguage["HFS"]["FS"]}}</th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["HFS"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["HFS"]["L"]}}<i @click="setSortTable('L')" :class="setSortLogo('L')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["HFS"]["HFST"]}}</th>
                                <th>{{this.getLanguage["HFS"]["HS"]}}</th>
                                <th>{{this.getLanguage["HFS"]["FS"]}}</th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_hfsl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_hfsl">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-trash" @click="removeHFS(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)">
                                        <i class="cil-trash" @click="removeHFS(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)">
                                        <i class="cil-trash"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-color-border" @click="editHFS(data.I, data.AGI)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)">
                                        <i class="cil-color-border" @click="editHFS(data.I, data.AGI)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)">
                                        <i class="cil-color-border"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <!--<td>{{ data.DN }}</td>-->
                            <td><span class="grid-line" v-for="domain in data.Domains">{{ domain.label }} <i v-if="domain.id.endsWith('-0')" class='fa-solid fa-globe text-info ml-1'></i></span></td>
                            <td><span class="grid-line" v-for="lang in data.Languages">{{ lang }} </span></td>
                            <td>{{ data.HFST }}</td>
                            <td>{{ substrContent(data.HS,20) }}</td>
                            <td>{{ substrContent(data.FS,20) }}</td>
                            <td>{{ data.CB }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.UB }}</td>
                            <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { integer, required } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_showSearchBar: true,
                sensBtn: true,
                bool_fullScreen: loadingFullScreen, //Full Screen
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "DI" }, { F: "L_csv", FA: true }, { F: "CTS", FV: { startDate: "", endDate: "" } }, { F: "SAGAGI" }], //Filter Value
                dd_do: [], // Domain Option
                dd_dofs: [], // Domain Option for search
                arry_hfsl: [], //header footer script list
                obj_ahfs: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    DN: null, //Domain Name
                    DI: null,
                    DAI: null, //Domain Alternate ID
                    L: null,
                    HS: null,
                    FS: null,
                    AGI: "",
                    SAGAGI: null,
                    AGIT: null,
                    AT: null,
                    HFST: null
                }, // add header footer script
                dd_lang: [],//language option
                dd_langfs: [],//language option
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option
                dd_subagentgroup: [], //subagent group option
                dd_DefaultSubBrand: [],
                rtSubBrand: 0,
                constAccessType: constAccessType
            }
        },
        validations: {
            obj_ahfs: {
                AGIT: { required },
                DIT: { required },
                DI: { required },
                L: { required }
            }
        },
        created() {
            this.$parent.showSubMenu = 'MS';
            this.$parent.showActiveMenu = 'MS.HFS';
            this.getLangauge();
            this.getAgentGroup();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.subAGI = this.getUserInfo.AGIBYPGI;

            if (this.getUserInfo.AT == 4) {
                this.getSubAgentGroup(0, true);
            }
            else {
                this.getHFSList();
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'getUserMemberSC']),

        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[3].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[3].FV.endDate = "";
                    }
                }
            },
            TextValueChange(type, event) {
                if (type == "HS") {
                    this.obj_ahfs.HS = event.target.value;
                }
                else if (type == "FS") {
                    this.obj_ahfs.FS = event.target.value;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('HFS', 'MS', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
                this.obj_ahfs['AGIT'] = null;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getHFSList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getHFSList();
                }
            },
            getLangauge() {
                var that = this;
                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_langfs = d.dropdownlist
                        }

                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            getSubAgentGroup(value, isFirstLoad = false) {
                var that = this;
                this.getDataApi(`/api/dd/subbrand/0/0/${value}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_DefaultSubBrand = that.deepClone(d.dropdownlist);

                            if (isFirstLoad) {
                                that.str_FV[4].FV = that.dd_DefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                that.getHFSList();
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3" && agi[0] != "4") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {
                this.str_FV[4].FV = null;
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                that.str_FV[0].FV = agi;
                                that.str_FV[4].FV = null;
                            }
                        });
                }
                else {
                    this.str_FV[0].FV = null;
                    this.str_FV[4].FV = null;
                    this.dd_dofs = [];
                }
                this.str_FV[1].FV = null;

            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value;
                    }
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                //that.str_FV[0].FV = agi;
                            }
                        });
                }
                else {
                    this.str_FV[4].FV = null;
                    this.dd_dofs = [];
                }
                this.str_FV[1].FV = null;

            },
            AgentGroupChange(value) {
                this.dd_do = [];

                if (this.obj_ahfs['I'] == 0)
                {
                    this.obj_ahfs['DIT'] = null;
                }

                this.obj_ahfs['SAGAGI'] = null;

                var that = this;
                var agi = 0;

                if (value != "")
                {
                    agi = value.split("-")[1];
                }

                this.getDataApi('/api/dd/dadn2/' + agi,
                    function (d, s) {
                        if (s)
                        {
                            that.dd_do = d.dropdownlist;
                            that.obj_ahfs.SAGAGI = null;
                        }
                    });

                that.sensBtn = ((that.isSENS == 1 && agi != that.curAGI) ? true : false);
            },
            SubAgentGroupChange(value) {
                if (this.obj_ahfs['I'] == 0) {
                    this.obj_ahfs['DI'] = null;
                }
                this.dd_do = [];
                var that = this;
                var agi = 0;

                if (value) {
                    agi = value;
                    this.obj_ahfs.AT = 4;

                    this.getDataApi(`/api/dd/dn-sag/` + agi,
                        function (d, s) {
                            if (s && d) {
                                that.dd_do = d.dropdownlist
                            }
                        });
                } else {
                    agi = this.obj_ahfs.AGIT.split("-")[1];
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s && d) {
                                that.dd_do = d.dropdownlist;
                                that.obj_ahfs.SAGAGI = null;
                            }
                        });
                }
            },
            DomainChange(value) {
                if (Array.isArray(value)) {
                    value = value[0];
                }
                var that = this;

                //Detect if includes '-' for Alternate Domain ID
                if (typeof value === 'string' && value.includes("-")) {
                    value = value.split("-")[0]; // Extract the first part (Domain ID) after splitting
                    value = parseInt(value);
                }

                //Find the correct language dropdown
                //Based on Main Domain ID
                if (value && value > 0) {
                    //if (that.obj_ahfs.AT == 4) {
                    if (that.obj_ahfs.SAGAGI) {
                        this.getDataApi(`/api/dd/dlang-sub/` + value, function (d, s) {
                            if (s) {
                                that.dd_lang = d.dropdownlist;
                            }
                        });
                    } else {
                        this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
                            if (s) {
                                that.dd_lang = d.dropdownlist;
                            }
                        });
                    }
                }
                else {
                    that.dd_lang = [];
                }
                if (that.obj_ahfs.I == 0)
                    that.obj_ahfs.L = null;
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_ahfs['AGIT'] && this.bool_isAMV) {
                    var agentList = this.obj_ahfs['AGIT'].split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.str_FV[0].FV && !this.bool_isAMV) {
                    var agentList = this.str_FV[0].FV.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            //DomainChangefs(value) {
            //    var that = this;
            //    if (value && value > 0) {
            //        this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
            //            if (s) {
            //                that.dd_langfs = d.dropdownlist;
            //            }
            //        });
            //    }
            //    else {
            //        that.dd_langfs = [];
            //    }
            //    that.str_FV[2].FV = [];
            //},
            getHFSList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV && i != 0 && i != 4) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                var split = this.str_FV[i].FV[x].split("-");

                                if (split.length == 2) {
                                    temp_ += split[1];
                                }
                                else {
                                    temp_ += split[0];
                                }
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                if (this.str_FV[4].FV) {
                    path += "&f[AGI]=" + this.str_FV[4].FV;
                } else if (this.str_FV[0].FV) {
                    path += "&f[AGI]=" + this.str_FV[0].FV;
                }

                this.getDataApi(`/api/hfs/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setHFSList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setHFSList(data) {
                this.arry_hfsl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setHFS(data) {
                this.obj_ahfs = Object.assign(this.obj_ahfs, data);
                this.bool_isAMV = true;
            },
            addHFS() {
                this.obj_ahfs = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    DI: null,
                    DIT: null, //Domain ID + Alternate Domain ID
                    DAI: null,
                    L: null,
                    HS: null,
                    FS: null,
                    AGI: "",
                    SAGAGI: null,
                    AGIT: null,
                    HFST: null
                };
                this.bool_CV = false;
                this.bool_isAMV = true;
                if (this.getUserInfo.AT === 4) {
                    this.getSubAgentGroup(0, true);
                }
                else {
                    this.dd_DefaultSubBrand = [];
                }


                if (this.dd_agentgroup[0].children == undefined) {
                    //var at = 0;
                    //at = this.dd_agentgroup[0].id.split("-")[0];
                    //if (at == 3 && this.dd_agentgroup.length < 2) {
                    this.obj_ahfs.AGIT = this.dd_agentgroup[0].id;
                    this.AgentGroupChange(this.obj_ahfs.AGIT);
                    //}
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_ahfs[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["HFS"][langKey]);
                    }
                }

            },
            saveHFS() {
                this.bool_CV = true;
                this.obj_ahfs['RS'] = 2;


                //removed previous iteration
                //for (var d of this.dd_do) {
                //    if (d.id == this.obj_ahfs['DI']) {
                //        this.obj_ahfs['DN'] = d.label;
                //    }
                //}

                //Separate DIT into Domain ID and Alternate Domain ID
                if (this.obj_ahfs.DIT != null) {

                    var domain = String(this.obj_ahfs.DIT).split("-");

                    //Used to clear cache & other function in api
                    this.obj_ahfs.DI = domain[0];
                    this.obj_ahfs.DAI = domain[1];
                    
                    this.obj_ahfs.DL = this.obj_ahfs.DIT.join();
                }

                if (this.obj_ahfs.AGIT != null && this.obj_ahfs.AGIT.length > 0) {
                    var agi = this.obj_ahfs.AGIT.split("-");
                    this.obj_ahfs.AGI = agi[1];
                }

                //when save, if got subagentid assign it into agentid
                if (this.obj_ahfs.SAGAGI) {
                    this.obj_ahfs.AGI = this.obj_ahfs.SAGAGI;
                }

                this.$v.obj_ahfs.$touch();
                if (!this.$v.obj_ahfs.$error) {
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/hfs/s`, this.obj_ahfs,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getHFSList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_ahfs"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            editHFS(id, agi) {
                this.bool_fullLoading = true;
                var that = this;
                var agit = agi;
                this.getSubAgentGroup(0)

                this.getDataApi(`/api/hfs/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setHFS(d.D);
                            that.bool_isAMV = false;
                            if (that.obj_ahfs.AGI != 0) {

                                var tempSAGAGI = that.obj_ahfs.SAGAGI;  //keep sagagi because when AgentGroupChange will assign null
                                that.obj_ahfs.AGIT = "3-" + that.obj_ahfs.AAGI;
                                if (tempSAGAGI > 0) {
                                    that.SubAgentGroupChange(tempSAGAGI);
                                    that.obj_ahfs.SAGAGI = tempSAGAGI;
                                } else {
                                    that.AgentGroupChange(that.obj_ahfs.AGIT);
                                    that.obj_ahfs.SAGAGI = null;
                                }
                            }

                            //Combine Domain ID & Alternate Domain ID for "DIT"
                            if (that.obj_ahfs.DL) {
                                that.obj_ahfs.DIT = that.obj_ahfs.DL.split(",");
                            } else {
                                that.obj_ahfs.DIT = [that.obj_ahfs.DI + "-" + that.obj_ahfs.DAI];                                
                            }
                            that.DomainChange(that.obj_ahfs.DIT);

                            that.bool_isAMV = true;
                        }
                    });
                that.sensBtn = ((that.isSENS == 1 && (agit != that.curAGI && agit != that.subAGI)) ? true : false);
            },
            removeHFS(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: data.I,
                            uts: data.UTS,
                            di: data.DI,
                            dai: data.DAI
                        };

                        this.postDataApi(`/api/hfs/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getHFSList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getHFSList();
            },
            setFlag(languageCode) {
                return this.mapLanguageFlag(languageCode);
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[3].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getHFSList();
            },
        },

    }

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Marketing/HeaderandFooterScripts.vue